import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import ServicesBody from './ServicesBody';
import ServicesData from './ServicesData';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected, intl } = props;

  return (
    <>
      <ServicesBody data={data} id={block} intl={intl} isEditMode />
      <SidebarPortal selected={selected}>
        <ServicesData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  data: PropTypes.object,
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
  intl: PropTypes.object,
};

export default Edit;
